import mediaProvider from '@/data-provider/mediaProvider';

export default {
  data() {
    return {
      uploadInProgress: false,
    };
  },
  methods: {
    async uploadMedia(id, data) {
      this.uploadInProgress = true;
      await mediaProvider.uploadMedia(id, data);
      this.uploadInProgress = false;
    },
  },
};
